import { render, staticRenderFns } from "./user_kjcx.vue?vue&type=template&id=a66ea5ec&"
import script from "./user_kjcx.vue?vue&type=script&lang=js&"
export * from "./user_kjcx.vue?vue&type=script&lang=js&"
import style0 from "./user_kjcx.vue?vue&type=style&index=0&id=a66ea5ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports